import script from "./ColorButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorButton.vue?vue&type=script&lang=ts&setup=true"

import "./ColorButton.vue?vue&type=style&index=0&id=7fa73bdc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa73bdc"]])

export default __exports__